import '../../styles/crud-editor.scss';
import {Dictionary} from 'lodash';
import {FieldSchema} from '../types';
import {Table, RawFieldRenderer, Button} from 'forms';
import {CollectionField} from '../fields';
import noop from 'lodash/noop';
import React from 'react';
import t from '@rcm/i18n-client';
import {TableCellRenderer} from '../renderers';

interface Props<T extends object> {
    creates?: Dictionary<T>;
    disabled?: boolean;
    schema?: FieldSchema[];
    onUpdate?: (entry: T, entryId: string) => void;
    onDiscard?: (entryId: string) => void;
}

const CrudCreateEditor = <T extends object>({
    creates = {},
    disabled = false,
    schema = [],
    onUpdate = noop,
    onDiscard = noop,
}: Props<T>) => {
    const schemaVisible = schema.filter((s) => !s.hidden);
    const entries = Object.entries(creates);
    return (entries.length > 0) ?
        <Table  cols={schemaVisible.length + 2}
                className="crud-editor-table crud-create-editor">
            {entries.map(([id, value], i) =>
                <tr key={id}>
                    { i === 0 ? <th>{t('Create')}</th> : <td /> }
                    <CollectionField Renderer={RawFieldRenderer}
                        SubRenderer={TableCellRenderer}
                        disabled={disabled}
                        schema={schema}
                        value={value}
                        // TODO: Very hacky. Fix ASAP as part of the react-hooks
                        //       refactor.
                        error={(value as any)?.tempErrors}
                        onValueChange={(v) => onUpdate(v, id)}
                    />
                    <td>
                        <Button
                            disabled={disabled}
                            btn="default"
                            icon="remove"
                            text={t('Discard')}
                            onClick={() => onDiscard(id)}
                        />
                    </td>
                </tr>
            )}
        </Table> :
        null;
};

export default CrudCreateEditor;
